/* eslint-disable no-dupe-keys */
export default {
  application: {
    name: "CPFL - Dashboard",
    shortDescription: "CPFL Total",
    title: "CPFL Total Dashboard",
    version: {
      title: "Versão",
      number: "1.0.0",
    },
    footer: {
      poweredBy: "Powered by",
      poweredByBrand: "MB Labs",
      poweredByBrandUrl: "https://mblabs.com.br",
    },
    currency: "R$",
    percent: "%",
    error: {
      networkMessage: "Network Error",
      network: "O servidor se encontra com problemas, tente mais tarde!",
      default: "Ocorreu um erro! Tente novamente mais tarde",
      defaultForm: "Ocorreu um erro! Verifique seus dados e tente novamente!",
    },
  },
  routes: {
    authAssertion: {
      pageTitle: "Entrando",
      url: "/auth-assertion",
    },
    logs: {
      pageTitle: "Logs",
      url: "/logs",
    },
    jobLog: {
      pageTitle: "Job Logs",
      url: "/joblogs",
    },
    jobMonitoring: {
      pageTitle: "Monitoramento de Jobs",
      url: "/jobMonitoring",
      content: {
        title: "Monitoramento de Jobs",
        subtitle: "Monitore os jobs do sistema",
      },
    },
    error: {
      pageTitle: "Erro",
    },
    login: {
      pageTitle: "Login",
      url: "/",
      messages: {
        welcome: "Seja bem vindo!",
      },
      errors: {
        fields: "Preencha os campos para efetuar o login",
        credentials: "Documento ou senha inválidos",
        serverError:
          "Houve um error ao contatar o servidor, tente novamente mais tarde.",
      },
      content: {
        title:
          "Negocie seu débito sem sair de casa e quite suas faturas de energia.",
        subtitle:
          "Você pode simular o seu parcelamento quantas vezes quiser e realizar o parcelamento sem burocracia.",
        hello: "Olá,",
        greetings:
          "bem-vindo, precisamos dos dados abaixo para continuar o acesso.",
        documentLabel: "CPF ou CNPJ",
        documentPlaceholder: "427.274.217-24",
        passwordLabel: "Senha",
        loginButton: "CONTINUAR",
        forgetPassword: "esqueci minha senha",
        firstAccess: "Primeiro acesso?",
        registerHere: " e cadastre-se",
        needHelp: "Precisa de ajuda?",
        helpChannel: " e tire suas dúvidas",
        clickHere: "Clique aqui",
      },
      form: {
        documentLabel: "CPF ou CNPJ",
        documentPlaceholder: "Insira o seu cpf aqui",
        passwordLabel: "Senha",
        passwordPlaceholder: "Insira a sua senha aqui",
        passConfirmLabel: "Confirmar Senha",
        passConfirmPlaceholder: "Confirme a sua senha aqui",
      },
    },
    reportDownloads: {
      pageTitle: "Central de downloads",
      url: "/report-downloads",
      title: "Central de downloads",
      subtitle: "Gerencie os dados exportados do CPFL Marketplace",
      content: {},
    },
    partner: {
      pageTitle: "Parceiro",
      url: "/partner",
      content: {},
    },
    distributor: {
      pageTitle: "Distribuidoras",
      url: "/distributor",
      content: {},
    },
    distributorDetail: {
      pageTitle: "Distribuidoras",
      url: "/distributor/:id",
      content: {},
    },
    partnerDetail: {
      pageTitle: "Detalhe de parceiro",
      url: "/partner/:id",
      content: {},
    },
    userCPFL: {
      pageTitle: "Usuários",
      url: "/userCPFL",
      content: {},
    },
    userPartner: {
      pageTitle: "Usuários",
      url: "/userPartner",
      content: {},
    },
    userCPFLDetail: {
      pageTitle: "Detalhe de usuário CPFL",
      url: "/userCPFL/:id",
      content: {},
    },
    clientsBlockList: {
      pageTitle: "Usuários BlockList",
      url: "/block-list/users",
      content: {},
    },
    clientBlockListForm: {
      pageTitle: "Detalhe do cliente BlockList",
      url: "/block-list/users/:id",
      content: {},
      register_title: "Cadastro clientes BlockList",
      register_subtitle: "Veja os detalhes e edite a BlockList",
      tittle: "Block List - Usuários",
      subtitle: "Gerencie a Block List do CPFL Marketplace",
      errors: {
        error: "ERROS",
        sucess: "SUCESSO",
        imported: "LINHAS IMPORTADAS",
        description_error: "DESCRIÇÃO ERROS",
        emptyColumn: "Células vazias",
        invalidDocument: "Documento inválido",
        documentAlreadyExists: "Documento já existente",
      },
    },
    citiesBlockList: {
      pageTitle: "Cidades BlockList",
      url: "/block-list/cities",
      content: {},
    },
    cityBlockListForm: {
      pageTitle: "Detalhe da cidade BlockList",
      url: "/block-list/cities/:id",
      content: {},
      register_title: "Cadastro cidades BlockList",
      register_subtitle: "Veja os detalhes e edite a BlockList",
      tittle: "Block List - Cidades",
      subtitle: "Gerencie a Block List do CPFL Marketplace",
      errors: {
        error: "ERROS",
        sucess: "SUCESSO",
        imported: "LINHAS IMPORTADAS",
        description_error: "DESCRIÇÃO ERROS",
        emptyColumn: "Células vazias",
        stateCityAlreadyBlocked: "Estado/Cidade ja bloqueado",
      },
    },
    userPartnerDetail: {
      pageTitle: "Detalhe de usuário financeira",
      url: "/userPartner/:id",
      content: {},
    },
    client: {
      pageTitle: "Clientes",
      url: "/client",
      content: {},
    },
    hashAgencyClient: {
      pageTitle: "Agência virtual",
      url: "/hash-agency",
      content: {},
    },
    clientDetail: {
      pageTitle: "Detalhe de cliente",
      url: "/client/:id",
      content: {},
    },
    clientNewComplaint: {
      pageTitle: "Cadastro de reclamação",
      url: "/client/:id/complaint/new",
      content: {},
    },
    clientEditComplaint: {
      pageTitle: "Edição de reclamação",
      url: "/client/:id/complaint/:complaintId/edit",
      content: {},
    },
    preContract: {
      pageTitle: "Pré-Contratos",
      url: "/pre-contract",
      content: {},
    },
    preContractConsolidated: {
      pageTitle: "Pré-Contratos Consolidados",
      url: "/consolidated/pre-contract",
      content: {},
    },
    dashboardConsolidated: {
      pageTitle: "Dashboard",
      url: "/consolidated/dashboard",
      content: {},
    },
    simulationPerClient: {
      pageTitle: "Pré-Contratos Consolidados por Cliente",
      url: "/consolidated/simulation-approves-per-client",
      content: {},
    },
    accessVirtualAgency: {
      pageTitle: "Acessos via agência virtual",
      url: "/consolidated/access-virtual-agency",
      content: {},
    },
    accessRedeFacilCode: {
      pageTitle: "Acessos via Código Rede Fácil",
      url: "/consolidated/access-rede-facil-code",
      content: {},
    },
    contractConsolidated: {
      pageTitle: "Contratos Fechados",
      url: "/consolidated/contract",
      content: {},
    },
    logErrorsConsolidated: {
      pageTitle: "Erros Consolidados",
      url: "/consolidated/errors",
      content: {},
    },
    clientsConsolidated: {
      pageTitle: "Clientes",
      url: "/consolidated/clients",
      content: {},
    },
    clientLogins: {
      pageTitle: "Logins",
      url: "/consolidated/client-logins",
    },
    accessConsolidated: {
      pageTitle: "Acessos",
      url: "/consolidated/access",
      content: {},
    },
    installment: {
      pageTitle: "Parcelas",
      url: "/installment",
      content: {},
    },
    contract: {
      pageTitle: "Contratos",
      url: "/contract",
      content: {},
    },

    installmentExpire: {
      pageTitle: "Parcelas Vencidas",
      url: "/installment/expire",
      content: {},
    },
    installmentPending: {
      pageTitle: "Parcelas Abertas",
      url: "/installment/pending",
      content: {},
    },
    installmentPaid: {
      pageTitle: "Parcelas Pagas",
      url: "/installment/paid",
      content: {},
    },
    contractDetail: {
      pageTitle: "Dados do contrato",
      url: "/contract/:id",
      content: {
        title: "Contrato ",
        subtitle: "Veja os detalhes de contrato",
        emptyState: "Você não possui nenhum contrato de empréstimo aberto",
        outstandingBalance: "Saldo devedor",
        totalAmount: "Valor Total do Contrato",
        totalInstallments: "Nº de parcelas",
        contractDate: "Data do contrato",
        downloadContract: "BAIXAR CONTRATO",
        protectionInsurance: "Status Seguro",
      },
    },
    faq: {
      pageTitle: "Dúvidas frequentes",
      url: "/faq",
      parent: "Início",
      child: "Dúvidas frequentes",
      content: {
        title: "Dúvidas frequentes",
      },
    },
  },

  components: {
    backButton: "VOLTAR",
    nextButton: "AVANÇAR",
    simulate: "SIMULAR EMPRÉSTIMO",
    agree: "CONCORDO",
    send: "ENVIAR",
    sider: {
      hello: "Olá, ",
      personalCode: "Seu Código: ",
      totalBillings: "Valor Total de Contas Abertas",
      menu: {
        home: "Início",
        contracts: "Meus contratos",
        invoices: "Minhas faturas",
      },
    },
    advancedCard: {
      balanceDue: "Saldo devedor",
      institution: "Financiadora",
      contract: "CONTRATO",
      totalContract: "VALOR TOTAL DO CONTRATO",
      numberOfBillings: "Nº DE PARCELAS",
      contractDate: "DATA DO CONTRATO",
      details: "DETALHES",
      currency: "R$ ",
      status: "STATUS",
    },
    invoiceTable: {
      header: {
        number: "Fatura",
        referringMonth: "Mês ref.",
        description: "Descrição da fatura",
        dueDate: "Vencimento",
        totalAmount: "Valor",
      },
    },
    addressPicker: {
      addressSelected: "Endereço selecionado",
      totalAmount: "Total à pagar: ",
    },
    userDropdown: {
      installationNumber: "NÚMERO DE INSTALAÇÃO",
      situation: "SITUAÇÃO",
      owner: "TITULAR DA CONTA",
      changeMyData: "Alterar meus dados",
      FAQ: "Dúvidas frequentes",
      settings: "Configuração da conta",
      logout: "Sair",
    },
    contractTable: {
      header: {
        number: "Parcelas",
        referenceMonth: "Mês ref.",
        source: "Origem da cobrança",
        dueDate: "Vencimento",
        totalAmount: "Valor",
        status: "Status",
      },
    },
  },
  createFile: {
    success: "Arquivos gerados e contrato enviado para o GMP",
  },

  success: {
    CREATED: "Inserido com sucesso!",
    UPDATED: "Atualizado com sucesso!",
  },

  errors: {
    DATE_FILTER_ERROR: "Selecione uma data inicial e final para a exportação",
    DATE_FILTER_PERIOD_INVALID:
      "Só é possível exportar entre um período máximo de 6 meses",
    DATE_FILTER_PERIOD_INVALID_LOGS:
      "Só é possível exportar entre um período máximo de 2 dias",
    USER_NOT_FOUND: "Cliente não encontrado",
    INVALID_SCHEMA: "O esquema informado é inválido",
    INVALID_PARAMETER: "O parâmetro informado é inválido",
    INVALID_ID: "O identificador informado é inválido",
    INVALID_NAME: "O nome informado é inválido",
    INVALID_EMAIL: "O email informado é inválido",
    INVALID_PASSWORD: "A senha informada é inválida",
    INVALID_RECAPTCHA: "O recaptcha informado é inválido",
    UNAUTHORIZED: "Não autorizado",
    TOKEN_EXPIRED: "O token foi expirado",
    NOT_FOUND: "Não foi possível encontrar",
    INVALID_PAGE: "A página é inválida",
    SOMETHING_WENT_WRONG: "Algo de errado aconteceu",
    DOCUMENT_ALREADY_USED: "O documento já esta sendo utilizado",
    NAME_ALREADY_USED: "O nome já esta sendo utilizado",
    INSTALLATION_NOT_FOUND: "Instalação não encontrada",
    GENERIC: "Houve um erro, tente novamente ou volte mais tarde",
    OracleException: "Houve um erro, tente novamente ou volte mais tarde",
    TaskCanceledException: "Houve um erro, tente novamente ou volte mais tarde",
    CommunicationException: "Houve um erro com o GMP",
    INSTALLATION_ALREADY_EXISTS: "Essa instalação já foi adicionada",
    NETWORK:
      "Houve um problema com a rede, verifique sua conexão ou tente novamente mais tarde",
    BACKOFFICE_USER_ALREADY_EXISTS: "Usuário já está cadastrado",
    BACKOFFICE_USER_NOT_FOUND: "Cliente não encontrado",
    CANNOT_BE_EMPTY: "Preencha o(s) campo vazio",
    INVALID_DOCUMENT: "Documento inválido",
    GMP_ERROR: "Houve um erro no GMP",
    GENERATE_EVIDENCE_FILES: "Erro ao gerar arquivos de evidência",
    BACKOFFICE_CLIENT_ALREADY_EXISTS_BLOCK_LIST:
      "Cliente já cadastrado na lista de bloqueio",
    BACKOFFICE_CITIES_ALREADY_EXISTS_BLOCK_LIST:
      "Cidade já cadastrada na lista de bloqueio",
    CLIENT_IS_NOT_FOUND_BLOCK_LIST: "Cliente não encontrado",
    INVALID_EMAIL: "Campo de e-mail é obrigatório",
    INVALID_EMAIL_FORMAT: "Formato de e-mail inválido",
    EMAIL_CANNOT_CONTAIN_ACCETS: "E-mail não pode conter acentos",
    CELLPHONE_CANNOT_BE_EMPTY: "Celular não pode ser vazio",
    CELLPHONE_CANNOT_HAVE_SPACE: "Celular não pode conter espaço",
    CELLPHONE_ONLY_NUMBERS: "Celular só pode conter números",
    CELLPHONE_INVALID: "Tamanho do número de celular inválido",
    INVALID_DDD_NUMBER: "Número do DDD do telefone inválido!",
    PERMISSION_DENIED: "Usuário sem permissão",
    CONTRACT_NOT_FOUND: "Contrato não encontrado",
    CLIENT_IS_BLOCK_LIST: "Usuário em Block-List CPFL",
    CONTRACT_CANCELLED: "Contrato cancelado",
  },
  enum: {
    profileType: {
      admin: "Administrador",
      user: "Usuário",
    },
  },

  JogLogPage: {
    Title: "Jobs da aplicação",
    Subtitle: "Gerencie os Jobs do CPFL Marketplace",
  },
};
